import script from "./ColoursDB.vue?vue&type=script&setup=true&lang=js"
export * from "./ColoursDB.vue?vue&type=script&setup=true&lang=js"

import "./ColoursDB.vue?vue&type=style&index=0&id=500e4ffa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500e4ffa"]])

export default __exports__